// extracted by mini-css-extract-plugin
export var cardHeader = "_tc-0";
export var reorderHandle = "_tc-3";
export var titleArea = "_tc-1";
export var titleAreaWithHandle = "_tc-2";